import { escape } from "lodash";
import { ApiError } from "../../../helpers/reactQueryApi";

// toastr renders its message as HTML, and server messages may contain
// user-chosen names (e.g. group names), so they are escaped here.
export default function saveErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.responseJson?.message) {
    return escape(error.message);
  }
  return I18n.t("js.activity.save_error_text.zero");
}
